<!-- 联系我们 -->
<template>
  <div class="frame">
    <div class="banner">
      <img class="banner-img" :src="bannerImg" alt="" />
    </div>
    <div class="box1">
      <div class="in">
        <div class="title-box">
          <div class="title">{{ $t("contact.title") }}</div>
          <div class="en">{{ $t("contact.en") }}</div>
          <div class="line"></div>
        </div>
        <div class="content">
          <p>{{ $t("contact.companyName") }}</p>
          <p>{{ $t("contact.phone") }}</p>
          <p>{{ $t("contact.address") }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bannerImg: require("@/assets/source/contact_banner.jpg"),
    };
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  background-color: #f6fbff;
  line-height: 0;

  .banner-img {
    width: 100%;
    height: auto;
    display: block;
    object-fit: contain;
  }
}

.title-box {
  position: relative;
  color: #fff;

  .title {
    font-size: 34px;
    position: relative;
    z-index: 2;
  }
  .en {
    font-size: 40px;
    font-weight: bolder;
    letter-spacing: 3px;
    background-image: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0.5),
      transparent
    );
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    position: absolute;
    left: 0;
    top: -40%;
    z-index: 1;
  }
  .line {
    width: 40px;
    height: 3px;
    margin: 20px 0 30px;
    background-color: $theme;
  }
}

.box1 {
  padding: 120px 0 80px;
  background-image: url(https://26823097.s61i.faiusr.com/2/AD0IuZPlDBACGAAgst6EgwYo0Pa21QEwgA84pAM.jpg);
  background-size: cover;
  background-position: center center;

  .in {
    width: 1200px;
    margin: 0 auto;

    .content {
      padding: 30px 0;
      font-size: 14px;
      color: #9496a1;
      display: flex;

      p + p {
        margin-left: 50px;
      }
    }
  }
}
</style>
